// Format currency untuk display di input (tanpa prefix Rp)
export const formatCurrencyInput = (value: any): string => {
  if (!value && value !== 0) return '';
  const numValue = typeof value === 'string' ? parseFloat(value.replace(/[^\d]/g, '')) : value;
  if (isNaN(numValue) || numValue === 0) return '';
  return new Intl.NumberFormat('id-ID').format(numValue);
};

// Parse currency string ke number (string angka tanpa format)
export const parseCurrency = (value: string): string => {
  if (!value) return '';
  // Hapus semua karakter non-digit
  return value.replace(/[^\d]/g, '');
};

// Convert currency string ke number untuk save
export const convertCurrencyToNumber = (
  value: string | number | null | undefined
): number | null => {
  if (!value) return null;
  if (typeof value === 'number') return value;
  const cleaned = value.toString().replace(/[^\d]/g, '');
  const numValue = parseFloat(cleaned);
  return isNaN(numValue) ? null : numValue;
};
